const CarSizeTypeComponent = () => import('@/views/WareHouse/CarSizeType/CarSizeTypeView')

export default [
    {
        path:'/CarSizeTypeIndex',
        name:'CarSizeTypeComponent',
        component:CarSizeTypeComponent
    }
]